module.exports = __webpack_public_path__ + "static/media/guesthouse-2.2.cf4be754.jpg";